import React from "react";
import Lottie from "lottie-react";
import loadingAnimation from "../assets/Animation - 1744204433056.json"; // عدّل المسار حسب مكان الملف

const Loader = () => {
  return (
    <div style={{
      width: "100%",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#fff", // أو حسب تصميمك
    }}>
      <Lottie animationData={loadingAnimation} loop={true} style={{ width: 400, height: 400 }} />
    </div>
  );
};

export default Loader;